import request from '@/utils/request'

export function login(mobile, password) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      mobile,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/index/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/auth.admin',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/auth.admin/add',
    method: 'post',
    data: data
  })
}

export function updateAdmin(data) {
  return request({
    url: '/admin/auth.admin/edit',
    method: 'post',
    data: data
  })
}

export function updateStatus(data) {
  return request({
    url: '/admin/auth.admin/edit',
    method: 'post',
    data: data
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/auth.admin/del?ids=' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/auth.admin/role?id='+id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/auth.admin/allocRole',
    method: 'post',
    data: data
  })
}

// 注册
export function registeApi(data){
  console.log(data)
  return request({
    url:'/admin/register',
    method:'post',
    data:data
  })
}

// export function teacherInfoApi(){
//   return request({
//     url:'/admin/user',
//     method:'get'
//   })
// }


// WEBPACK FOOTER //
// ./src/api/login.js